export default "__VITE_ASSET__4c41baa1__"